module.exports = __webpack_public_path__ + "static/media/big_bass_day_at_the_races.pragmaticplay.98bc091c.jpeg";